import firebase from "@/fire/firebase";

const storage = firebase.storage();
const storageRef = storage.ref();
const uploadsRef = storageRef.child("uploads");

export default {
  upload(file: any, category: String) {
    let fileRef = uploadsRef.child(category + "/" + file.name);
    return fileRef.put(file).then(function(snapshot) {
      return snapshot.ref.getDownloadURL();
    });
  }
};
